import { render } from "./MobileMain.vue?vue&type=template&id=1ab6eebe&lang=pug"
import script from "./MobileMain.vue?vue&type=script&lang=js"
export * from "./MobileMain.vue?vue&type=script&lang=js"

import "./MobileMain.vue?vue&type=style&index=0&id=1ab6eebe&lang=scss"
script.render = render

export default script
import QDrawer from 'quasar/src/components/drawer/QDrawer.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QPageContainer from 'quasar/src/components/page/QPageContainer.js';
import QLayout from 'quasar/src/components/layout/QLayout.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDrawer,QScrollArea,QPageContainer,QLayout});
